import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Mail, Phone, Clock } from "lucide-react";
import { toast } from "sonner";
import { apiError } from "@/lib/format";
import { PageHeader, EmptyState } from "@/components/Page";

export default function Kontaktanfragen() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/contact")
      .then((r) => setRows(r.data || []))
      .catch((e) => toast.error(apiError(e)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <PageHeader
        title="Kontaktanfragen"
        subtitle="Nachrichten aus dem Kontaktformular auf teamtempus.de."
        testid="kontaktanfragen-header"
      />

      {loading ? (
        <div className="text-sm text-slate-400 py-10 text-center" data-testid="kontakt-loading">Wird geladen…</div>
      ) : rows.length === 0 ? (
        <Card className="border-slate-200 rounded-xl"><EmptyState icon={Mail} title="Noch keine Anfragen" testid="kontakt-empty" /></Card>
      ) : (
        <div className="grid gap-4">
          {rows.map((c) => (
            <Card key={c.id} className="p-5 border-slate-200 rounded-xl" data-testid={`kontakt-${c.id}`}>
              <div className="flex items-start justify-between gap-4 flex-wrap">
                <div className="min-w-0">
                  <div className="font-semibold text-slate-900">{c.name}</div>
                  <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-1 text-sm text-slate-500">
                    <a href={`mailto:${c.email}`} className="flex items-center gap-1.5 hover:text-slate-800"><Mail className="h-3.5 w-3.5" /> {c.email}</a>
                    {c.phone && <a href={`tel:${c.phone}`} className="flex items-center gap-1.5 hover:text-slate-800"><Phone className="h-3.5 w-3.5" /> {c.phone}</a>}
                    <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" /> {c.created_at ? new Date(c.created_at).toLocaleString("de-DE") : ""}</span>
                  </div>
                </div>
                <Badge variant="outline" className={c.emailed ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-amber-50 text-amber-700 border-amber-200"}>
                  {c.emailed ? "E-Mail zugestellt" : "Nur gespeichert"}
                </Badge>
              </div>
              <p className="mt-3 pt-3 border-t border-slate-100 text-sm text-slate-700 whitespace-pre-line">{c.message}</p>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
